import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import works from "../data/works";
import Skill from "../components/Skill";


const Works = () => {
  const [filteredData, setFilteredData] = useState(works);
  const [animationKey, setAnimationKey] = useState(0); // Add animation key state

  const handleFilterData = (e) => {
    const filterAttribute = e.currentTarget.getAttribute("data-filter");

    const activeClassElements = document.querySelectorAll(
      ".portfolio-filter ul li"
    );
    activeClassElements.forEach((element) => {
      element.classList.remove("active");
    });

    e.currentTarget.classList.add("active");

    if (filterAttribute === "*") {
      setFilteredData(works);
    } else {
      const filteredData = works.filter(
        (work) => work.category === filterAttribute
      );
      setFilteredData(filteredData);
    }

    setAnimationKey((prevKey) => prevKey + 1); // Increment animation key
  };
  return (
    <section className="portfolio_area" id="portfolio">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="main_title text-left">
              <h2>Portfolio</h2>
              <p>Recently Works</p>
            </div>
          </div>
        </div>
        <div className="filters portfolio-filter">
          <ul>
            <li
              className="active"
              data-filter="*"
              onClick={(e) => handleFilterData(e)}
            >
              all
            </li>
            <li data-filter="website" onClick={(e) => handleFilterData(e)}>
              Websites
            </li>
            <li data-filter="desktop" onClick={(e) => handleFilterData(e)}>
              Desktops
            </li>
            <li data-filter="mobile" onClick={(e) => handleFilterData(e)}>
              Mobiles
            </li>
          </ul>
        </div>

        <div
          className="filters-content portfolio_details_inner"
          key={animationKey}
        >
          <div className="row  portfolio-grid justify-content-center">
            {filteredData &&
              filteredData.map((work) => (
                <div
                  className={`all col-lg-4 col-md-6 ${work.category}`}
                  key={work.id}
                >
                  <div className="portfolio_box">
                    <div className="single_portfolio">
                      <img
                        className="img-fluid w-100"
                        src={work.banner}
                        alt={work.title}
                      />
                      <div className="overlay"></div>
                      <a
                        href={work.demo}
                        target="_blank"
                        rel="noreferrer"
                        className="img-gal"
                      >
                        <div className="icon">
                          <FontAwesomeIcon
                            icon={faEye}
                            fontSize={50}
                            color="#4458dc"
                          />
                        </div>
                      </a>
                    </div>
                    <div className="short_info">
                      <h4>{work.title}</h4>
                      <p>{work.description}</p>
                    </div>
                    <div className="techs">
                      {work.technologies &&
                        work.technologies.map((tech) => (
                          <Skill
                            title={tech.label}
                            icon={tech.icon}
                            key={tech.id}
                          />
                        ))}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Works;
